import { Component } from '@angular/core';

import { Register } from '../../shared';


@Register({
  name: 'importExport',
  title: 'igo.importExport',
  icon: 'import_export'
})
@Component({
  selector: 'igo-import-export-tool',
  template: require('./import-export-tool.component.html'),
  styles: [require('./import-export-tool.component.styl')]
})
export class ImportExportToolComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/import-export-tool/import-export-tool.component.ts